import Excludable from './Excludable'

export default class Hideable extends Excludable {
  public visible: boolean = true

  public constructor(...args: any[]) {
    super(args)
    this.processData(args)
  }

  public get isVisible() {
    return this.visible && this.isIncluded
  }

  public processData(data: any) {
    if (Array.isArray(data)) {
      data = data.flat(3).at(0)
    }

    super.processData(data)

    if (data.visible !== undefined) {
      this.visible = data.visible
    }
  }
}
